import React, { PureComponent, Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import { PositionedTooltip } from 'common/components/core/tooltip';
import { animatedClusterMarkerFactory } from 'common/components/core/markers/AnimatedClusteredMarker';
import Icon from 'common/components/core/icon';

import theme from './ClusterMarker.scss';

const MARKER_HEIGHT = 48;
const MARKER_WIDTH = 48;

const defaults = {
    clusterMarkerStyle: {
        position: 'absolute',
        width: MARKER_WIDTH,
        height: MARKER_HEIGHT,
        left: -MARKER_WIDTH / 2,
        top: -MARKER_HEIGHT / 2
    }
};

class ClusterMarkerComponent extends PureComponent {
    static defaultProps = {
        tooltipText: null,
        overrideStyle: defaults.clusterMarkerStyle
    };

    onClick = clickEvent => {
        const { onClick } = this.props;
        onClick && onClick(clickEvent);
    };

    onHover = e => {
        const { onHover, isDisabled, onDisabledElementHover } = this.props;
        if (isDisabled) {
            onDisabledElementHover?.();
        } else {
            onHover?.(e);
        }
    };

    onHoverOut = () => {
        const { onHoverOut } = this.props;
        onHoverOut?.();
    };

    render() {
        const {
            $hover,
            childBeingEdited,
            childSelectedForEdit,
            color,
            id,
            clusterCount,
            overrideStyle,
            theme,
            tooltipText,
            isDisabled,
            markerLabel,
            markerIcon
        } = this.props;
        var wrapClassName = classnames(theme.clusterMarkerWrap, theme[color], {
            [theme.markerHover]: $hover,
            [theme.childSelectedForEdit]: childSelectedForEdit,
            [theme.childIsBeingEdited]: childBeingEdited
        });
        const tooltipContent = tooltipText ? (
            <div className={theme.tooltipContent}>
                <span className={theme.tooltipText}>
                    {clusterCount} markers
                </span>
                <span className={theme.subtext}>{tooltipText}</span>
            </div>
        ) : null;
        return isDisabled ? (
            <div
                className={classnames(theme.disabledMarker, theme[color])}
                onMouseEnter={this.onHover}
                onMouseOut={this.onHoverOut}
            />
        ) : (
            <div
                key={id}
                className={wrapClassName}
                style={overrideStyle}
                onClick={this.onClick}
                onMouseEnter={this.onHover}
                onMouseOut={this.onHoverOut}
            >
                {tooltipContent ? (
                    <PositionedTooltip
                        isHovered={$hover}
                        theme={theme}
                        tooltipPosition="bottom"
                        tooltipDelay={200}
                        tooltip={tooltipContent}
                    />
                ) : null}
                <Icon
                    theme={theme}
                    icon={markerIcon}
                    wrapBgColor={color}
                    numberLabel={markerLabel}
                />
            </div>
        );
    }
}
const ThemedClusterMarker = themr(
    'ClusterMarker',
    theme
)(ClusterMarkerComponent);

const enhanceMarkerToZoomInOnSingleClick = Marker => {
    return class ZoomEnhancedMarker extends Component {
        componentDidMount() {
            var element = ReactDOM.findDOMNode(this);
            element.addEventListener('click', this.onClick);
        }

        componentWillUnmount() {
            var element = ReactDOM.findDOMNode(this);
            this.clickListener = element.removeEventListener(
                'click',
                this.onClick
            );
        }

        onClick = clickEvent => {
            clickEvent.stopPropagation();
            var element = ReactDOM.findDOMNode(this);
            var doubleClickEvent = new MouseEvent('dblclick', clickEvent);
            element.dispatchEvent(doubleClickEvent);
            if (this.props.onClick) {
                this.props.onClick(clickEvent);
            }
        };

        render() {
            return <Marker {...this.props} />;
        }
    };
};

const ZoomEnhancedClusterMarker = enhanceMarkerToZoomInOnSingleClick(
    ThemedClusterMarker
);
const ZoomEnhancedAnimatedClusterMarker = animatedClusterMarkerFactory(
    ZoomEnhancedClusterMarker
);
const AnimatedClusterMarker = animatedClusterMarkerFactory(ThemedClusterMarker);

export default ThemedClusterMarker;
export {
    ZoomEnhancedAnimatedClusterMarker,
    ThemedClusterMarker as ClusterMarker,
    AnimatedClusterMarker
};
